export default {
  colors: {
    white: '#ffffff',
    whiteSmoke: '#f7f7f7',
    blue: '#075674',
    gunMetal: '#2e2f47',
    darkGunMetal: '#353656',
    isabelline: '#ebebeb',
    isabellineDark: '#e0e2e4',
    blueGray: '#383955',
    blueLight: '#3face7',
    blueDark: '#337ab7',
    manatee: '#9c9eb9',
    magicPotion: '#ff4465',
    blueYankees: '#25253a',
    blackRich: '#10111d',
    greenUfo: '#33d46c',
    grayGradient:
      'linear-gradient(113deg, rgba(102, 104, 143, 0.6), rgba(102, 104, 143, 0.15))',
    black: '#202020',
    blackDark: '#212233',
    blackRgba5: 'rgba(0, 0, 0, 0.5)',
    blackRgba15: 'rgba(0, 0, 0, 0.15)',
    gray: '#292926',
    grayLight: '#CECCCB',
    grayDark: '#3C3C3B',
  },
  sizes: {
    xs: '400px',
    sm: '576px',
    md: '728px',
    lg: '992px',
    lm: '1100px',
    xl: '1200px'
  },
  fontSizes: {
    tiny: '9px',
    small: '11px',
    regular: '12px',
    menu: '13px',
    large: '14px',
    xLarge: '16px',
    regularLarge: '20px',
    xxLarge: '24px',
    menuLarge: '28px',
    xxxLarge: '36px'
  },
  fontFamily: {
    main: 'Lexend Deca, sans-serif'
  }
};
